export const NavDropdownSeparator = () => {
  return <div className="border-b border-gray-200" />;
};
